<template>
    <div>
        <div v-cloak class="pt-lg-1 container-fluid">
            <div class="row align-items-end">
                <!--/* bandeau lien et icône panier */-->
                <cart-banner
                    :cart-link="accessorySelector.cartUrl"
                    :number-of-items="accessorySelector.cartBannerDTO.numberOfItemsInCart"
                    :cart-enabled="cartEnabled"
                    :search-field-place-holder="accessorySelector.searchFiltersDto.cartBannerSearchLabel"
                    :search-results-url="accessorySelector.searchFiltersDto.searchResultsUrl"
                    :search-results-query-additional-params="accessorySelector.searchFiltersDto.searchResultsQueryAdditionalParams"
                    :algolia-api-key="accessorySelector.searchFiltersDto.algoliaDto.apiKey"
                    :algolia-app-id="accessorySelector.searchFiltersDto.algoliaDto.appId"
                    :algolia-index-name="accessorySelector.searchFiltersDto.algoliaDto.indexName"
                    class="col-12 col-md-5 order-1 order-md-2 mb-1"
                />
                <h1 class="col-12 col-md-7 order-2 order-md-1">
                    {{ accessorySelector.title }}
                </h1>
            </div>

            <div id="mobile-filters" class="row mb-1">
                <div class="d-flex">
                    <div v-if="!showAccessorySpinner" id="total-mobiles">
                        <p class="font-size-16 lead fw-bold mb-0">
                            {{ numberOfAccessoryAvailable }}
                        </p>
                    </div>

                    <ob1-drop-down
                        id="mobile-sortBy"
                        :is-button="true"
                        class="ms-auto"
                        :drop-down-dto="dropDownDto"
                        @ob1-drop-item-click="sortAccessories"
                    />

                    <ob1-liens-icone
                        :is-button="true"
                        modal-id="filters-modal"
                        :title="accessorySelector.filterTitle"
                        class="ms-1"
                        data-bs-toggle="modal"
                        icon="icon-filter"
                        type="button"
                    />
                </div>

                <div class="slide-popin-modal">
                    <slide-popin-modal-filter :id="'filters-modal'" :aria-labelledby="'mobile-filters'">
                        <ob1-liens-icone
                            icon="icon-trash"
                            :is-button="true"
                            :title="categoriesSelected"
                            class="mt-1 noDefaultStyleButton"
                            @click="deleteSelectionHandler"
                        />
                        <hr class="separator separator--gray4 my-1">
                        <selector-shelves
                            ref="selectorShelves"
                            class="mb-2"
                            :shelves="shelvesToShow"
                            @change-check-boxes="shelvesHandler"
                        />
                    </slide-popin-modal-filter>
                </div>
            </div>

            <div class="row d-flex justify-content-space-between">
                <ob1-message-alerte
                    v-if="noAccessoryError"
                    :title="noAccessoryError"
                    icon="icon-info"
                    type="info"
                />
                <selector-accessories-display
                    v-else
                    :accessories="accessories"
                    :show-accessory-bloc="showAccessoryBloc"
                    :show-accessory-spinner="showAccessorySpinner"
                    :show-more-accessories-button="showMoreAccessoriesButton"
                    :wording-button-more-accessories="accessorySelector.wordingButtonMoreAccessories"
                    :list-limit="listLimit"
                    :filters="filters"
                    :sort="sort"
                    :funding-details-dto="accessorySelector.fundingDetailsDto"
                    @fetch-accessories="showSpinnerOrAccessories"
                />
            </div>
        </div>
        <div v-if="accessorySelector.pxfEnabled && accessorySelector.legalMentions.pxfMention" class="container-fluid mt-2 mb-2">
            <p class="fw-bold" v-html="accessorySelector.legalMentions.pxfMention" />
        </div>
        <div class="bg-gray2 mt-1 pt-1 pb-1">
            <div class="container-fluid">
                <legal-mentions4x-cb
                    v-if="accessorySelector.cb4xEnabled && accessorySelector.legalMentions.cb4xMention"
                    :label="accessorySelector.legalMentions.cb4xMention"
                    :popin4x-cb="accessorySelector.legalMentions.popin4xCb"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CartBanner from '../common/CartBanner.vue'
import SelectorShelves from './SelectorShelves.vue'
import SelectorAccessoriesDisplay from "./SelectorAccessoriesDisplay.vue";
import LegalMentions4xCb from "../common/components/LegalMentions4xCb.vue";
import SlidePopinModalFilter from "../common/selector/fragment/SlidePopinModalFilter.vue";

const accessorySelector = JSON.parse(document.getElementById('accessory-selector').dataset.accessorySelector);

export default {
    components: {
        SlidePopinModalFilter,
        LegalMentions4xCb,
        CartBanner,
        SelectorShelves,
        SelectorAccessoriesDisplay
    },
    data: function(){
        return {
            accessorySelector: accessorySelector,
            accessories: [],
            cartEnabled: accessorySelector.cartUrl != null,
            shelves: [],
            numberOfAccessoryAvailable: "",
            numberOfSelectedCategories: 0,
            dropDownDto: accessorySelector.dropDownDto,
            sort: accessorySelector.sort,
            filters: accessorySelector.filtersSeoIds,
            showAccessorySpinner: false,
            shelfFilterList: accessorySelector.shelfFilterList,
            categoryFilterList: accessorySelector.categoryFilterList,
            subCategoryFilterList: accessorySelector.subCategoryFilterList,
            showMoreAccessoriesButton: false,
            showAccessoryBloc: false,
            noAccessoryError: null,
            listLimit: accessorySelector.listLimit
        }
    },
    computed: {
        categoriesSelected: function () {
            return accessorySelector.deleteFiltersLabel + ' (' + this.numberOfSelectedCategories + ')'
        },
        currentUrl: function () {
            return new URL(window.location.href)
        },
        shelvesToShow: function () {
            return this.shelves.filter(item => item.show);
        }
    },
    created: function () {
        this.accessorySelector.accessoryShelves.forEach(shelf => {
            // On construit la checkbox "Afficher tout"
            const showAllCheckBox = {
                checkBoxId: shelf.seoId + '-show-all',
                label: 'Afficher tout',
                isChecked: false,
                isIndeterminated: false
            }

            // On construit les checkboxes des catégories et sous-catégories
            const checkBoxes = []
            shelf.categories.forEach(category => {
                const subCategoriesCheckBoxes = []
                if (category.subCategories !== undefined) {
                    category.subCategories.forEach(subCategory => {
                        subCategoriesCheckBoxes.push({
                            label: subCategory.shortLabel,
                            isChecked: false,
                            isIndeterminated: false,
                            accessoriesCount: subCategory.accessoriesCount,
                            seoId: subCategory.seoId,
                            checkBoxId: 'subcategory-' + category.seoId + '-' + subCategory.seoId
                        })
                    })
                }
                const categoriesCheckBoxes = {
                    label: category.shortLabel,
                    isChecked: false,
                    isIndeterminated: false,
                    accessoriesCount: category.accessoriesCount,
                    seoId: category.seoId,
                    checkBoxId: 'category-' + category.seoId,
                    subCategoriesCheckBoxes: subCategoriesCheckBoxes,
                }

                checkBoxes.push(categoriesCheckBoxes)
            })

            this.shelves.push({
                seoId: shelf.seoId,
                label: shelf.shortLabel,
                showAllCheckBox: showAllCheckBox,
                checkBoxes: checkBoxes,
                show: shelf.show
            })
        })
    },
    mounted: function () {
        this.init(accessorySelector.filtersSeoIds);
        this.scrollToTile();
    },
    methods: {
        init: function () {
            const pageIndex = this.currentUrl.searchParams.get("page") ?? 1;
            const data = {
                seoIds: [],
                from: 0,
                to: pageIndex * this.listLimit,
                sort: this.sort
            }
            if (this.filters && this.filters.length > 0) {
                data.seoIds = this.filters;
                this.checkUrlFilters(this.filters);
                this.countNumberOfSelectedCategories();
            }
            this.showSpinnerOrAccessories(data);
        },
        shelvesHandler: function () {
            this.countNumberOfSelectedCategories()
            this.filterAccessories()
        },
        countNumberOfSelectedCategories: function () {
            this.numberOfSelectedCategories = 0
            this.shelves.forEach(shelf => {
                shelf.checkBoxes.forEach(category => {
                    if (category.subCategoriesCheckBoxes.length > 0) {
                        category.subCategoriesCheckBoxes.forEach(subCategory => {
                            if (subCategory.isChecked) {
                                this.numberOfSelectedCategories++
                            }
                        })
                    } else {
                        if (category.isChecked) {
                            this.numberOfSelectedCategories++
                        }
                    }
                })
            })
        },
        sortAccessories: function (sort) {
            Tms.link({category: "selecteur_produit", action: sort.id, label: "tri"});
            this.sort = sort.id;
            this.filterAccessories();
        },
        deleteSelectionHandler: function () {
            this.updateUrl([], [], [], this.sort);
            this.$refs.selectorShelves.$refs.selectorShelf.forEach(selectorShelf => selectorShelf.checkBoxesReinitialisation());
            this.numberOfSelectedAccessories = 0
            this.numberOfSelectedCategories = 0
            this.filters = []
            const data = {
                seoIds: this.filters,
                from: 0,
                to: this.listLimit,
                sort: this.sort
            }
            this.showAccessoryBloc = false
            this.showSpinnerOrAccessories(data)
        },
        filterAccessories: function () {
            this.showAccessoryBloc = false
            this.filters = [];
            this.shelfFilterList = [];
            this.categoryFilterList = [];
            this.subCategoryFilterList = [];
            //récupération des seoIds des catégories et sous-catégories checked
            this.shelves.forEach(shelf => {
                const categories = shelf.checkBoxes
                if (categories.every(category => category.isChecked)) {
                    this.addSeoIdToFilters(shelf.shelfId);
                    this.shelfFilterList.push(shelf.seoId);
                } else {
                    categories.forEach(category => {
                        if (category.isChecked) {
                            this.addSeoIdToFilters(category.seoId);
                            this.categoryFilterList.push(category.seoId);
                        } else {
                            const subCategories = category.subCategoriesCheckBoxes
                            subCategories.forEach(subCategory => {
                                if (subCategory.isChecked) {
                                    this.addSeoIdToFilters(subCategory.seoId);
                                    this.subCategoryFilterList.push(subCategory.seoId);
                                }
                            })
                        }
                    })
                }
            })
            this.filters = this.shelfFilterList.concat(this.categoryFilterList, this.subCategoryFilterList)

            //suppression catégories en double
            this.filters = [...new Set(this.filters)];
            this.shelfFilterList = [...new Set(this.shelfFilterList)];
            this.categoryFilterList = [...new Set(this.categoryFilterList)];
            this.subCategoryFilterList = [...new Set(this.subCategoryFilterList)];
            const data = {
                seoIds: this.filters,
                from: 0,
                to: this.listLimit,
                sort: this.sort
            }

            this.showSpinnerOrAccessories(data)
            this.updateUrl(this.shelfFilterList, this.categoryFilterList, this.subCategoryFilterList, this.sort);
        },
        addSeoIdToFilters: function (seoId) {
            this.filters.push(seoId);
        },
        fetchAccessories: function (data) {
            let url = accessorySelector.accessoriesApiBaseUrl

            if (data.seoIds !== undefined && data.seoIds.length > 0) {
                url = addParam(url, 'seoIds=' + data.seoIds)
            }
            url = addParam(url, 'from=' + data.from)
            url = addParam(url, 'to=' + data.to)
            if (data.sort && data.sort !== "par-defaut") {
                url = addParam(url, "sort=" + data.sort)
            }
            if (data.page) {
                url = addParam(url, 'pageIndex=' + this.currentUrl.searchParams.get("page"))
            }

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                });
            });
        },
        showSpinnerOrAccessories: function (data) {
            this.showAccessorySpinner = true
            this.fetchAccessories(data).then(result => {
                if (result.startIndex === 0) {
                    this.accessories = result.accessories
                } else {
                    this.accessories.push.apply(this.accessories, result.accessories)
                }
                this.numberOfAccessoryAvailable = result.numberOfAvalaibleAccessory;
                this.showMoreAccessoriesButton = result.showMoreAccessories;
                this.showAccessorySpinner = false
                this.showAccessoryBloc = true
                this.noAccessoryError = result.noAccessoryError
            }).catch((error) => {
                    if (error.status !== 0) {
                        window.location.href = dto.infoViewUrl;
                    }
                }
            );
        },
        scrollToTile: function () {
            if (this.showAccessorySpinner === true) {
                window.setTimeout(this.scrollToTile, 100)
            } else {
                const currentSeoId = this.currentUrl.searchParams.get("seoId");
                const currentTile = document.getElementById(currentSeoId)
                if (currentTile) {
                    currentTile.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
                }
            }

        },
        checkUrlFilters: function () {
            //si on arrive dans le selecteur par une url qui contient le mot selection
            this.checkIfSelectionFilter()

            //si on arrive sur le sélecteur par une url dont les paramètres sont classés par type
            if (this.shelfFilterList) {
                this.shelfFilterList.forEach(shelfFilter => {
                    this.checkShelf(shelfFilter)
                })
            }
            if (this.categoryFilterList) {
                this.categoryFilterList.forEach(categoryFilter => {
                    this.checkCategory(categoryFilter)
                })
            }
            if (this.subCategoryFilterList) {
                this.subCategoryFilterList.forEach(subCategoryFilter => {
                    this.checkSubCategory(subCategoryFilter)
                })
            }
        },
        updateUrl: function (shelfFilterList, categoryFilterList, subCategoryFilterList, sort) {
            let url = accessorySelector.accessoriesSelectionUrl;
            if (shelfFilterList.length > 0) {
                url = addParam(url, 'rayon=' + shelfFilterList.join(','));
            }
            if (categoryFilterList.length > 0) {
                url = addParam(url, 'categorie=' + categoryFilterList.join(','));
            }
            if (subCategoryFilterList.length > 0) {
                url = addParam(url, 'sous_categorie=' + subCategoryFilterList.join(','));
            }
            if (sort && sort !== "" && sort !== "par-defaut") {
                url = addParam(url, 'sort=' + sort)
            }
            history.replaceState(null, 'Boutique Accessoires', url)
        },
        checkShelf: function (shelfFilter) {
            const currentShelf = this.$refs.selectorShelves.$refs.selectorShelf.find(shelf => shelf.shelfId === shelfFilter)
            if (currentShelf) {
                currentShelf.showAllCheckBox.isChecked = true
                currentShelf.showAllHandler(false)
            }
        },
        checkCategory: function (categoryFilter) {
            this.$refs.selectorShelves.$refs.selectorShelf.forEach(shelf => {
                const categories = shelf.checkBoxes;
                const currentCategory = categories.find(category => category.seoId === categoryFilter)
                if (currentCategory) {
                    currentCategory.isChecked = true
                    shelf.categoryHandler(categoryFilter, false)
                }
            })
        },
        checkSubCategory: function (subCategoryFilter) {
            this.$refs.selectorShelves.$refs.selectorShelf.forEach(shelf => {
                const categories = shelf.checkBoxes
                let currentSubCategory
                categories.forEach(category => {
                    const subCategories = category.subCategoriesCheckBoxes
                    currentSubCategory = subCategories.find(subCategory => subCategory.seoId === subCategoryFilter)
                    if (currentSubCategory) {
                        currentSubCategory.isChecked = true
                        shelf.subCategoryHandler(subCategoryFilter, false)
                    }
                })
            })
        },
        checkIfSelectionFilter: function () {
            if (this.filters) {
                for (let seoId of this.filters) {
                    this.checkShelfOrCategoryOrSubCategory(seoId)
                }
            }
        },
        checkShelfOrCategoryOrSubCategory: function (seoId) {
            if (accessorySelector.accessoryShelves.find(shelf => shelf.seoId === seoId)) {
                this.checkShelf(seoId)
            } else {
                accessorySelector.accessoryShelves.forEach(shelf => {
                    const categories = shelf.categories
                    if (categories && categories.find(category => category.seoId === seoId)) {
                        this.checkCategory(seoId)
                    } else {
                        categories.forEach(category => {
                            const subcategories = category.subCategories
                            if (subcategories && subcategories.find(subcategory => subcategory.seoId === seoId)) {
                                this.checkSubCategory(seoId)
                            }
                        })
                    }
                })
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables', 'msh_mixins';

#mobile-filters {
    display: flex;
    justify-content: flex-end;
}

.noDefaultStyleButton {
    background: none;
    border: none;
}

// On surcharge le style par défaut OB1. Vu avec le studio, on peut avoir une checkbox avec un label
// en gras ou normal
label[for*="subcategory"] {
    font-weight: normal;
}

</style>
